// @flow
/* eslint-disable */
if (
  !global._babelPolyfill
  && !window._babelPolyfill
) {
  require('@babel/polyfill');
}
import React from 'react';
import * as Sentry from '@sentry/browser';
import mixpanel from 'mixpanel-browser';
import {
  render as reactRender,
} from 'react-dom';
import {
  Provider,
} from 'react-redux';
import {
  hot,
  setConfig,
  cold,
} from 'react-hot-loader';

import type {
  ComponentType,
} from 'react';

import config from 'chronos-config';

import AppErrorBoundary from './containers/AppErrorBoundary';
import rootSaga from './sagas';
import store from './store';
import pjson from '../package.json';
/* eslint-enable */

if (config.useSentry) {
  Sentry.init({
    dsn: 'https://0983c63be47e4cf8baf8fb8fa8ab2aba@sentry.io/1376683',
    release: pjson.version,
  });
}
if (config.useMixpanel) {
  mixpanel.init('71c519efc55a6bfcdde2414f315af656');
}

setConfig({
  pureSFC: true,
  onComponentCreate: type => (
    String(type).indexOf('useState') > 0
      || String(type).indexOf('useEffect') > 0
  ) && cold(type),
});

function load() {
  store.runSaga(rootSaga);
  const rootEl = window.document.getElementById('app');
  const render = Component => (
    reactRender(
      <Provider store={store}>
        <Component />
      </Provider>,
      rootEl,
    )
  );
  render(hot(module)(AppErrorBoundary));
}

if (document.readyState === 'complete') {
  load();
} else {
  window.addEventListener(
    'load',
    () => {
      load();
    },
  );
}
